import type { DisbursementAccountType } from '../model/disbursement-account-type';

export const providersKeys = {
  all: () => ['providers'] as const,
  byAccountType: (accountType: DisbursementAccountType) =>
    [...providersKeys.all(), accountType] as const,
};
